function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import Immutable from 'seamless-immutable';
import * as actions from './actions';
var initialState = Immutable.from({
  isFetching: false,
  error: false,
  loggedIn: false,
  isUpdating: false
});
export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref.type,
      payload = _ref.payload,
      error = _ref.error;

  switch (type) {
    case actions.REQUEST_USER_INFORMATION:
      return state.merge({
        isFetching: true,
        error: false
      });

    case actions.RECEIVE_USER_INFORMATION:
      if (error) {
        return state.merge({
          error: true,
          isFetching: true
        });
      }

      return state.merge(_objectSpread({
        isFetching: false,
        error: false,
        loggedIn: true
      }, payload));

    case actions.REQUEST_UPDATE_ACCOUNT:
      return state.merge({
        isUpdating: true
      });

    case actions.RECEIVE_UPDATE_ACCOUNT:
    case actions.RECEIVE_UPDATE_ACCOUNT_ERROR:
      return state.merge({
        isUpdating: false
      });

    default:
      return state;
  }
});
//# sourceMappingURL=reducer.js.map